import { useDispatch, useSelector } from 'react-redux';
import api from './axiosInstance.js';
import { showToast } from '../redux/toasterSlice.js';
import {
  setGeneratedImages,
  setImageError,
  setImageLoading,
  setLastPayload,
} from '../redux/createImageSlice.js';
import { updatePastCreationData } from '../redux/pastCreateionsSlice.js';

export const useIncrementalPrompting = () => {
  const dispatch = useDispatch();
  const { name, email } = useSelector((state) => state.auth);

  const incrementalPrompting = async (inputValue, fetchViewDetailData, font, fontInputValue) => {
    const font_id = font ? font.md5 : fetchViewDetailData?.md5hash;
    const fontFamilyUrl = font ? font.family_url : fetchViewDetailData?.fontFamilyUrl;
    const fontName = font ? font.font_name : fetchViewDetailData?.fontFamily;
    const foundryName = font ? font.foundry_name : fetchViewDetailData?.foundryName;

    const api_name = 'incremental_prompt';
    const incrementalPayload = {
      api_name,
      instruct_prompt: inputValue,
      updated_font_prompt: fontInputValue,
      user_prompt: fetchViewDetailData?.prompt,
      magic_prompt: fetchViewDetailData?.enhancedPrompt,
      font_id,
      prompt_id: fetchViewDetailData?.promptId,
      image_path: `${process.env.REACT_APP_AWS_BUCKET_URL_OTHER}/${fetchViewDetailData?.images}`,
      username: name,
      email,
      fontFamilyUrl,
      fontName,
      modelName: fetchViewDetailData?.modelName,
      foundryName,
    };

    try {
      dispatch(setImageLoading(true));
      dispatch(setLastPayload(incrementalPayload));
      dispatch(
        showToast({
          message: `Generating new visuals using ${fontName} fonts`,
          type: 'info',
        }),
      );
      const response = await api.post(`/edit-image`, incrementalPayload);
      const data = response.data.data;

      dispatch(setGeneratedImages(data.image));
      dispatch(updatePastCreationData(data.image));
      dispatch(showToast({ message: 'Visuals generated successfully', type: 'success' }));
    } catch (error) {
      dispatch(setImageError(error.response.data.message));
      dispatch(showToast({ message: 'Failed to generate images', type: 'error' }));
    }
  };

  return incrementalPrompting;
};
